import { useMutation } from 'react-query';

import { setSubProgramPreferenceImportance as mutationFn } from 'api/endPoints/setSubProgramPreferenceImportance';

interface ISetSubProgramPreferenceImportancePayload {
    projectId: number;
    subProgramId: number;
    topCriticalityPercent: number;
    completionPercent: number;
    isNeedRefresh: boolean;
}

export const useMutationSetSubProgramPreferenceImportance = () => {
    return useMutation<string, QueryError, ISetSubProgramPreferenceImportancePayload>((params) => mutationFn(params));
};
